export var D6MotionType;
(function (D6MotionType) {
    D6MotionType[D6MotionType["eX"] = 0] = "eX";
    D6MotionType[D6MotionType["eY"] = 1] = "eY";
    D6MotionType[D6MotionType["eZ"] = 2] = "eZ";
    D6MotionType[D6MotionType["eTWIST"] = 3] = "eTWIST";
    D6MotionType[D6MotionType["eSWING1"] = 4] = "eSWING1";
    D6MotionType[D6MotionType["eSWING2"] = 5] = "eSWING2";
})(D6MotionType || (D6MotionType = {}));
export var D6Axis;
(function (D6Axis) {
    D6Axis[D6Axis["eLOCKED"] = 0] = "eLOCKED";
    D6Axis[D6Axis["eLIMITED"] = 1] = "eLIMITED";
    D6Axis[D6Axis["eFREE"] = 2] = "eFREE";
})(D6Axis || (D6Axis = {}));
export var D6Drive;
(function (D6Drive) {
    D6Drive[D6Drive["eX"] = 0] = "eX";
    D6Drive[D6Drive["eY"] = 1] = "eY";
    D6Drive[D6Drive["eZ"] = 2] = "eZ";
    D6Drive[D6Drive["eSWING"] = 3] = "eSWING";
    D6Drive[D6Drive["eTWIST"] = 4] = "eTWIST";
    D6Drive[D6Drive["eSLERP"] = 5] = "eSLERP";
})(D6Drive || (D6Drive = {}));
